// Module
var code = "<div class=\"dropdown\"> <a title=\"Basket\" class=\"text-sm sps-btn sps-btn-outline btn-color-basket\" data-toggle=\"dropdown\"> <i class=\"fa fa-shopping-basket\"></i> <span class=\"badge\">4</span> </a> </div>";
// Exports
export default code;